import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { travelRepository } from '@webapp/modules/expense/data-access/repositories/TravelRepository'
import { travelQueryConfig } from '@webapp/modules/expense/query-configs/travel'

export const useMutateBatchDenyTravels = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, number[]>({
    mutationFn: (travelIds) => travelRepository.deny(travelIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: travelQueryConfig.approvableListBase().queryKey,
      })
    },
  })

  return {
    batchDeny: (travelIds: number[]) => mutation.mutateAsync(travelIds),
    isDenying: mutation.isLoading,
  }
}
